function removeAccountX(){
  function walk(n){
    if(!n)return;
    var times=String.fromCharCode(215);
    if(n.nodeType===3){
      var t=n.textContent.trim();
           if(t==='×'||t===times||t==='X'||t==='x'){n.textContent=''}
    }else if(n.nodeType===1){
      if(n.children.length===0){
        var t=n.textContent.trim();
               if(t==='×'||t===times||t==='X'){n.style.display='none'}
      }
      for(var i=0;i<n.childNodes.length;i++){walk(n.childNodes[i])}
      if(n.shadowRoot){walk(n.shadowRoot)}
    }
  }
  walk(document.body);
}
removeAccountX();
setTimeout(removeAccountX,500);
setTimeout(removeAccountX,1500);
var observer=new MutationObserver(function(){removeAccountX()});
observer.observe(document.body,{childList:true,subtree:true});


// ============================================
// 功能2：Get Started页面隐藏导航/登录/按钮，保留logo
// ============================================
(function hideHeaderExtras() {
  if (!window.location.pathname.toLowerCase().includes('get-started')) return;
  var keywords = ['explore', 'our story', 'journal', 'community', 'log in', 'login', 'try for free', 'search'];
  function processRoot(root) {
    if (!root.querySelectorAll) return;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length > 5) continue;
      var text = el.textContent.trim().toLowerCase();
      if (!text || text.length > 30) continue;
      for (var j = 0; j < keywords.length; j++) {
        if (text.indexOf(keywords[j]) > -1) {
          el.style.display = 'none';
          var r = el.getRootNode ? el.getRootNode() : null;
          if (r && r.host && r.host !== document) r.host.style.display = 'none';
          break;
        }
      }
    }
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) processRoot(all[i].shadowRoot);
    }
  }
  function run() { processRoot(document); }
  setTimeout(run, 200);
  setTimeout(run, 800);
  setTimeout(run, 2000);
})();


// ============================================
// 功能3：Get Started页面 - 页眉改深色背景
// ============================================
(function setHeaderDark() {
  if (!window.location.pathname.toLowerCase().includes('get-started')) return;

  function setBg() {
    var header = document.querySelector('header') 
              || document.querySelector('header-drawer')
              || document.querySelector('.header');
    if (!header) return;
    // 外层header
    header.style.backgroundColor = '#1F363D';
    header.style.background = '#1F363D';
    // 穿透shadow DOM，给内部所有元素设背景
    function walkShadow(root) {
      if (!root.querySelectorAll) return;
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        all[i].style.backgroundColor = '#1F363D';
        all[i].style.background = '#1F363D';
        if (all[i].shadowRoot) walkShadow(all[i].shadowRoot);
      }
    }
    if (header.shadowRoot) walkShadow(header.shadowRoot);
  }

  setTimeout(setBg, 300);
  setTimeout(setBg, 1000);
  setTimeout(setBg, 2500);
})();


// ============================================
// 功能3：修复购物车按钮跳转到Get Started页面
// ============================================
function fixCartButton(){
  var btns=document.querySelectorAll('a[href="/cart"], a.header-actions__action--cart');
  for(var i=0;i<btns.length;i++){
    var btn=btns[i];
    if(btn.textContent && btn.textContent.indexOf('Try for free')!==-1 && !btn.dataset.fixed){
      btn.dataset.fixed='true';
      btn.setAttribute('href','/pages/get-started');
      btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href='/pages/get-started';
      },true);
    }
  }
}
fixCartButton();
setTimeout(fixCartButton,500);
setTimeout(fixCartButton,1500);
var cartObserver=new MutationObserver(function(){fixCartButton()});
cartObserver.observe(document.body,{childList:true,subtree:true});
// Get Started页面：给body加标识类 + 等组件注册完成后设置Logo反白
if (window.location.pathname.indexOf('get-started') > -1) {
  document.body.classList.add('is-get-started-page');

  // 等待页眉自定义元素完全注册、Shadow DOM生成后再执行
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-component').then(function() {
      var headerComp = document.querySelector('header-component');
      if (!headerComp || !headerComp.shadowRoot) return;

      // 穿透Shadow DOM，找到内部所有SVG（包含Logo），统一设置反白
      var allSvgs = headerComp.shadowRoot.querySelectorAll('svg');
      for (var i = 0; i < allSvgs.length; i++) {
        allSvgs[i].style.filter = 'brightness(0) invert(1)';
      }
    });
  }
}
